function StopWatchIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 87 87"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M54.375 3.625h-21.75v7.25h21.75v-7.25zM68.984 26.79l5.147-5.147c-1.558-1.849-3.262-3.589-5.111-5.111l-5.147 5.147C58.253 17.183 51.184 14.5 43.5 14.5c-18.016 0-32.625 14.61-32.625 32.626S25.448 79.75 43.5 79.75c18.053 0 32.625-14.61 32.625-32.626 0-7.684-2.683-14.753-7.141-20.336zM43.5 72.501c-14.029 0-25.375-11.347-25.375-25.376 0-14.028 11.346-25.375 25.375-25.375s25.375 11.347 25.375 25.376C68.875 61.154 57.529 72.5 43.5 72.5z" />
      <path d="M43.5 25.375a21.75 21.75 0 11-18.35 33.426L43.5 47.126v-21.75z" />
    </svg>
  )
}

export default StopWatchIcon
